<script setup>
const openTrengo = () => {
  document.querySelector('.trengo-chat-button').click();
};
</script>

<template>
  <div
    class="chat"
    @click="openTrengo()"
  >
    <strong class="chat__text">{{ $t('general.header.chat') }}</strong>
  </div>
</template>

<style scoped lang="scss">
.chat:hover {
  cursor: pointer;
}
</style>

<style scoped lang="scss">
.chat {
  padding-right: 0.8rem;
  text-decoration: none;

  &__text::after {
    content: '';
    display: inline-block;
    width: 3rem;
    height: 3rem;
    background: url('@/assets/svg/icons/chat.svg') no-repeat;
    vertical-align: middle;
    margin-left: 0.5rem;
  }
}
</style>
